import { Radio } from 'antd';

const GanttFilterZoom = ({ t, zoomUnit, onClickZoomButton }) => {
  return (
    <Radio.Group
      defaultValue={zoomUnit}
      key={zoomUnit}
      buttonStyle="solid"
      optionType="button"
      className={'radio-group--bg'}
      // className={`${styles.radioButtonGroup}`}
    >
      {/*<Radio.Button
                  value="week"
                  checked={zoomUnit === 'week'}
                  className={styles.radioButton}
                  onClick={() => onClickZoomButton({ unit: 'week' })}
                >
                  Week/Day
                </Radio.Button>*/}
      <Radio.Button checked={zoomUnit === 'day'} value="day" onClick={() => onClickZoomButton({ unit: 'day' })}>
        {t('gantt.filter.month')}
      </Radio.Button>
      <Radio.Button value="month" checked={zoomUnit === 'month'} onClick={() => onClickZoomButton({ unit: 'month' })}>
        {t('gantt.filter.year')}
      </Radio.Button>
    </Radio.Group>
  );
};

export default GanttFilterZoom;
